import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Typography, Fab, makeStyles, Theme, createStyles, LinearProgress } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import Constants from '../../types/constants';
import { InEditingMode, IGlobalState, InEditingType } from '../../states/GlobalState';
// import EditUserModeRead from './EditUserModeRead';
import AgencyFields from './fields';
import { useGlobal, useDispatch } from 'reactn';
import apiService from '../../services/api'
import { useHistory, useLocation } from 'react-router-dom';
// import { useNotifyUser } from '../../utils/myHooks';
import {CustomDialog} from '../../dialog/CustomDialog';
// import UserService from '../../services/UserService';
// import { useAuthDataContext } from '../../services/auth-data-hooks';
import { Agency } from '../../models/agency';
import { useNotifyUser } from '../../utils/hooks';
import ConfirmDialog from '../../dialog/ConfirmDialog';
import { LoggerServiceProvider, useLogger } from '../../logger';
import { deleteAgency } from '../../services/agencyService';
import { getIdentityFromStorage } from '../../types/auth';
import { Roles } from '../../models';

const contentMaxWidth = Constants.PageEditCompanyContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    locked: {
        color: theme.palette.error.main,
        marginLeft: theme.spacing(2),
    },
    agencyheader: {
        display: 'flex',
        maxWidth: contentMaxWidth,
        flex: '0 0 36px',
    },
    containerMain: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        paddingTop: '8px'
    },
    fab: {
        marginLeft: theme.spacing(1),
    },
}))

type EditAgencyPropsType = {
    initialMode: InEditingMode,
    isGroup?: boolean,
}

export default function AgencyEdit({initialMode, isGroup}: EditAgencyPropsType) {
    const submitFunctionRef = useRef<() => Promise<any>>(); //Referenza ad una funzione
    const refreshFunctionRef = useRef<() => void>() //Referenza ad una funzione
    const dispatch = useDispatch()
    const [currentEditAgency,] = useGlobal<IGlobalState, 'currentEditAgency'>('currentEditAgency')
    // const [newUserNextOid] = useGlobal<IGlobalState, 'newUserNextOid'>('newUserNextOid')
    const [, setCurrentEditStatus] = useGlobal<IGlobalState, 'currentEditAgencyStatus'>('currentEditAgencyStatus')
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [/*confirmCloneDialogOpen*/, setConfirmCloneDialogOpen] = useState(false);
    const [working, setWorking] = useState(false)
    const agencyEdit = currentEditAgency; 
    const [identity, setIdentity] = useGlobal<IGlobalState, 'identity'>('identity');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const history = useHistory();
    // const location = useLocation();
    const classes = useStyles();
    const logger = useLogger({key: 'agency'});

    //Definisco la callback alla submit
    const handleSetSubmitCallback = (callback: () => Promise<any>) => submitFunctionRef.current = callback;
    const handleSetRefreshCallback = (callback: () => void) => refreshFunctionRef.current = callback;

    // const handleMode = (newmode: InEditingMode) => {
    //     const inedit: InEditingType | null = currentEditAgency
    //     if (inedit) {
    //         if (inedit.mode === InEditingMode.Edit && newmode === InEditingMode.Read && submitFunctionRef.current) {
    //             submitFunctionRef.current().then(() => {
    //                 setEditMode(inedit.mode)
    //             })
    //         } else {
    //             inedit.mode = newmode;
    //             setEditMode(newmode);
    //         }
    //     }
    // }
    const handleSubmit = () => {
        console.log('*** *** *** SUBMIT END *** *** ***');
        // currentEditAgency /*&& setEditMode(currentEditAgency.mode)*/;
    }

    /* Cancellazione */
    const doDelete = (item: Agency) => {
        deleteAgency(ip, auth.authData!, auth.user!, item.Id).then(result => {
            setWorking(true);
            console.log('Deleted agency', result)
            if(result === false) {
                logger.error(`Errore nella cancellazione ${item.Id} [${result}]`);
            } else if(result === true) {
                logger.info(`Cancellazione ${item.Id} riuscita [${result}]`);
            }
            return dispatch.removeInEditAgency(item.Id);
        }).finally(() => { 
            setWorking(false) 
            history.replace('/agency')
        });
    }
    
    const handleDelete = () => {
        console.log('*** +++ handleDelete')
        if(currentEditAgency) {
            setConfirmDialogOpen(true)
        }
    }

    // const handleClone = () => {
    //     console.log('*** +++ handleClone')
    //     if(currentEditAgency) {
    //         setConfirmCloneDialogOpen(true)
    //     }
    // }
    
    const handleRefresh = () => {
        console.log('*** +++ handleRefresh')
        refreshFunctionRef.current && refreshFunctionRef.current();
        // TODO
        console.log('lo stato diventa pristine');
        setCurrentEditStatus('Pristine');
    }

    const handleBack = () => {
        history.push('/agency');
    }

    const handleSaveNew = () => {
        if(submitFunctionRef.current) {
            console.log('Sto per eseguire la current che è la submitform di Formik');
            submitFunctionRef.current();
        }
    }
    const closeConfirmDialog = (event: {}) => setConfirmDialogOpen(false)
    const closeConfirmCloneDialog = (event: {}) => setConfirmCloneDialogOpen(false)

    const confirmDelete = (context?: any) => {
        setConfirmDialogOpen(false)
        // TODO
        currentEditAgency && doDelete(currentEditAgency.agency);
    }
    
    return (
        <React.Fragment>
            <div className={classes.containerMain}>
                <div className={classes.agencyheader}>
                    {/* <Typography variant='h5'>
                        {agencyEdit.agency.Id > 0 ? (<small><small><em>({agencyEdit.agency.Id > 0 ? agencyEdit.agency.Id : 'NUOVO'})</em></small></small>) : null}
                    </Typography> */}
                    <div style={{ flex: '1 1' }}>&nbsp;</div>
                    <div style={{ flex: '0 0' }}>
                        <Fab color='primary' size='small' className={classes.fab} 
                            onClick={(event) => handleBack()} title='Indietro'><BackIcon /></Fab>
                    </div>
                    {identity && identity.Role === Roles.SUPERADMIN ?
                    <>
                    <div style={{ flex: '0 0' }}>
                        <Fab color='secondary' size='small' className={classes.fab} style={{backgroundColor: 'rgba(0, 161, 216, 1.0)' }} 
                            onClick={(event) => handleSaveNew()} title='SALVA Modifiche'><SaveIcon /></Fab>
                    </div>
                    <div style={{ flex: '0 0' }}>
                        {currentEditAgency?.mode !== InEditingMode.New ? (<Fab color='default' size='small' className={classes.fab} 
                            onClick={(event) => handleDelete()} title='Elimina Studio'><DeleteIcon /></Fab>) : null}
                    </div>
                    </>
                    : null}
                </div>
                {/* here is starting the part of resume Agency */}
                {currentEditAgency ? (
                    <EditFields
                        setSubmitCallback={handleSetSubmitCallback} 
                        setRefreshCallback={handleSetRefreshCallback} 
                        onSubmit={handleSubmit} />
                    ) :
                    <div></div>
                }
            </div>
            {working && <LinearProgress color='primary' />}
            <ConfirmDialog open={confirmDialogOpen} cancel={closeConfirmDialog} confirm={confirmDelete} 
                title={'Cancellazione Studio'} 
                prompt={"Cancello lo studio?"}>
                <Fragment>
                    <Typography variant='body1'>{'Agency'} <strong>{agencyEdit && agencyEdit.agency ? agencyEdit.agency.Name : ' insert mode'}</strong></Typography>
                    <p></p>
                </Fragment>
            </ConfirmDialog>
        </React.Fragment>
    );
};

type AgencyFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void
}
const EditFields = ({setSubmitCallback, setRefreshCallback, onSubmit}: AgencyFieldsPropsType) => {
    return (
        <AgencyFields setSubmitCallback={setSubmitCallback} setRefreshCallback={setRefreshCallback} onSubmit={onSubmit} />
    )
}

